module.exports = __webpack_public_path__ + "img/cases-brand-avic-13.80ee41be.jpg";